<template>
  <div class="monitoringall">
    <el-dropdown trigger="click" @command="handleCommand">
      <span class="el-dropdown-link">
        {{ itemTitle }}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <div id="inp">
          <input id="div-inp" text="checkbox" v-model="felice"  />
          <div id="sousuo">
            <i class="el-icon-search"></i>
            <!-- <img src="../../../assets/img/search.png" alt="" /> -->
          </div>
        </div>
        <div v-if="IsShow > 0" class="NoShow">{{ textNo }}</div>

        <div class="hodern">
          <el-dropdown-item
            v-for="(item, index) in message"
            :key="index"
            :command="index"
            :class="{active:meUrl==item.url}"
          >
            <p>{{ item.name }}</p></el-dropdown-item
          >
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { chainIndex } from "../../../api/linkindex";
export default {
  name: "monitoringall",
  props:{
    linkurl:String
  },
  data() {
    return {
      IsShow: 0,
      itemTitle: "",
      felice: "",
      id: "",
      message: [],
      meUrl: "",
      textNo: "",
    };
  },
  mounted() {
    this.forEtem();
  }, 
  watch: {
    linkurl(n,o){
      this.meUrl = n
      this.itemTitle = this.message.filter(e=>{return e.url==n})[0].name
    },
    felice(val) {
      this.felice = val;
      this.id = this.$store.state.project.currentProject.projectId;

      chainIndex.monitoring(this.id).then((res) => {
        this.message = res.data.data.result.filter(
          (array) => {
            //  console.log(array)
            if (array.areaName.match(this.felice) !== null) {
              return array;
            } else if (this.felice == "") {
              return this.message;
            }
          }
          //娶不到array值
        );
      });
      // console.log(111111111)
    },

    message(o, n) {
      if (this.message.length == 0) {
        this.IsShow = 1;
        this.textNo = "暂无数据";
      } else {
        this.IsShow = 0;
        this.textNo = "";
      }
    },
  },
  methods: {
    forEtem() {
      this.id = this.$store.state.project.currentProject.projectId;
      chainIndex.monitoring(this.id).then((res) => {
        this.message = res.data.data.result;
     this.message=this.message.map(item=>{
           
       return item
      }).sort((a,b)=>{
          return a.areaId-b.areaId
        })   
        this.itemTitle = this.message[0].name;
        this.meUrl = this.message[0].url;
        this.$emit("wrid", this.meUrl);
      });
    },

    handleCommand(command) {
      this.id = this.$store.state.project.currentProject.projectId;
      this.itemTitle = this.message[command].name;
      this.meUrl = this.message[command].url;
    //   console.log(this.meUrl);
      this.$emit("wrid", this.meUrl);
    },
  },
};
</script>
<style scoped lang="less">
.el-dropdown-menu__item.active{
  background-color: #ecf5ff;
    color: #66b1ff;
}
.monitoringall {
  position: relative;
  width: 280rem !important;
  max-height: 400rem !important;
}
::v-deep .el-dropdown-link:focus {
  outline: none;
}
.el-dropdown-link {
  width: 500rem;
  position: absolute;
  color: #ffffff;
  font-size: 18rem;
  cursor: pointer;
  left: 30rem;
  top: 20rem;
}
.el-dropdown-menu {
  width: 290rem !important;
  left: 16% !important;
  top: 13% !important;
}
.popper__arrow {
  margin-left: 0 !important;
}
#inp {
  width: 248rem;
  height: 32rem;
  background: rgba(252, 250, 250, 0.15);
  border: 1rem solid rgba(0, 0, 0, 0.15);
  border-radius: 16rem;
  margin-left: 16rem;
  margin-bottom: 16rem;
  padding: 5rem 18rem 0rem 15rem;
  display: flex;
  justify-content: space-between;
  #div-inp {
    background: rgba(252, 250, 250, 0.15);
    color: #999999;
    .w(120);
    font-size: 16rem;
    border: none;
    outline: none;
  }
}

#sousuo {
  .w(18);
  .h(18);
  margin-left: -10rem;
}
.el-icon-search {
  font-size: 18rem;
}
.NoShow {
  position: absolute;
  height: 24rem;
  color: gray;
  font-size: 16rem;
  text-align: center;
  top: 80rem;
  left: 0;
  right: 0;
  margin: auto;
}

.hodern {
  height: 300rem !important;
  max-height: 300rem;
  width: 260rem;
  overflow-y: scroll;
  overflow-x:hidden ;
  text-overflow: ellipsis;
  white-space: nowrap;
   scrollbar-width: none;
    -ms-overflow-style: none;
    p{
      overflow-x:hidden ;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
}
.hodern::-webkit-scrollbar {
  width: 8rem;
  height: 72rem;
  background: #fff;
}
div::-webkit-scrollbar-track {
  width: 8rem;
  height: 72rem;
  background: #fff;
  border-radius: 4rem;
}
div::-webkit-scrollbar-thumb {
  width: 8rem;
  height: 72rem;
  background: #bfbfbf;
  border-radius: 10rem;
}
</style>